export const COLOR_SUCCESS = '#5cb85c';
export const COLOR_DANGER = '#a94442';
